<template>
  <div class="container-fluid">
    <div v-for="err in errors" class="alert alert-danger" :key="err.field">
    {{err.value}}
  </div>
  <h4>Детальная страница пользователя</h4>
  <el-form label-width="160px"  label-position="left" id="uploadForm" name="uploadForm">
    <el-form-item label="Имя">
      <el-input v-model="query.name" disabled></el-input>
    </el-form-item>
    <el-form-item label="Роль">
      <el-select
      v-model="query.role"
      placeholder="Укажите роль"        
      >
        <el-option
          v-for="(item, index) in userRoleConfig"
          :key="index"
          :value="item.field"
          :label="item.title"
        />                    
      </el-select>
    </el-form-item>
      <el-form-item label="Активность">
      <el-checkbox v-model="query.activity"></el-checkbox>
    </el-form-item>
    <el-form-item label="Адрес">
        <el-input v-model="query.address" disabled></el-input>
    </el-form-item>
    <el-form-item label="Дата рождения">
        <el-input v-model="query.birthDate" disabled></el-input>
    </el-form-item>
    <el-form-item label="Почта">
        <el-input v-model="query.email" disabled></el-input>
    </el-form-item>
    <el-form-item label="Почта подтверждена">
      <p v-if="!query.emailVerified">Нет</p>
      <p v-if="query.emailVerified">Да</p>
    </el-form-item>
    <el-form-item label="Телефон">
        <el-input v-model="query.phone" disabled></el-input>
    </el-form-item>
    <el-form-item label="ИНН" v-if="query.payerType === userProfileType.individual.value">
        <el-input v-model="query.inn" disabled></el-input>
    </el-form-item>
    <el-row v-if="query.payerType === userProfileType.legal.value">
      <h5> Данные компании </h5>
      <el-form-item label="Название компании">
          <el-input v-model="query.company.name" disabled></el-input>
      </el-form-item>
      <el-form-item label="Адрес">
        <el-input v-model="query.company.address" disabled></el-input>
      </el-form-item>
        <el-form-item label="ИНН">
          <el-input v-model="query.company.inn" disabled></el-input>
      </el-form-item>
      <el-form-item label="КПП">
          <el-input v-model="query.company.kpp" disabled></el-input>
      </el-form-item>
    </el-row>
    <el-form-item>
      <el-button type="primary" @click="updateUserData">Изменить</el-button>
      <el-button @click="goToBack">Назад</el-button>
    </el-form-item>
  </el-form> 
  </div>
</template>

<script>
import axios from "axios";
import userRoleConfig from '../../composable/config/user-role.config';
import useFormRequest from '../../composable/useFormRequest'
import userEditRequestConfig from '../../composable/config/user-edit-request.config';
import getErrors from '../../composable/utils/getErrors';
import userProfileType from '../../composable/type/user-profile.type';
import { SETPRELOADER_STATE } from '@/store/mutation-types'

export default {
name: "UserUpdate",
  data: function (){
    return{
      userRoleConfig,   
      userProfileType,   
      query: {
        role: "",
        activity: false,
        name: "",
        address: "",
        birthDate: "",
        email: "",
        emailVerified: false,
        phone: "",
        payerType: "",
        inn: "",
        company: {
         name: "",
         address: "",
         inn: "",
         kpp:  "",
        }
      },
      errors: [],
      user: undefined
    }
  },
  mounted(){
    this.getUser()
  },
  methods:{
    getUser:function() {
      this.$store.commit(SETPRELOADER_STATE, true) 
      const id = this.$route.params.id;
      if (id) {
        axios.get('user/' + id)
        .then((response) => {
          this.user = response.data;
          this.setQuery(response.data);          
        })
        .catch(() => {
          this.$notify.console.error('Не удалось получить данные пользователя')
        })
        .finally(() => {
          this.$store.commit(SETPRELOADER_STATE, false) 
        })
      }
    },
    updateUserData() {
      this.$store.commit(SETPRELOADER_STATE, true)

      const id = this.$route.params.id;

      const { convertToRequestProps, setConfig } = useFormRequest();
      setConfig(userEditRequestConfig)
      const data = convertToRequestProps(this.query);

      axios.put(`/user/${id}`, data).then(() => {
          this.$notify.success('Данные изменены')
        }
      ).catch((errors) => {
          if (errors.response.status === 401) {
              this.$router.push('/login');
          }
          if(errors.response.status === 422) {
            this.setErrors(errors.response.data.errors)
          }
      })
      .finally(() => {
        this.$store.commit(SETPRELOADER_STATE, false)
      });
    },
    setQuery(value) {
      if (value) {
        this.query.role = value.role || '';
        this.query.activity = value.activity || false;
        this.query.name = value.name || '';
        this.query.address = value.address || '';
        this.query.birthDate = value.birth_date || '';
        this.query.email = value.email || '';
        this.query.emailVerified = value.email_verified || false;
        this.query.phone = value.phone || '';        
        this.query.payerType = value.payer_type;
        this.query.inn = value.inn || '';

        this.query.company.name = value.company?.name || '';
        this.query.company.address = value.company?.address || '';
        this.query.company.inn = value.company?.inn || '';
        this.query.company.kpp = value.company?.kpp || '';
        
      }
    },
    setErrors(err) {
      this.errors = getErrors(err)
    },
    goToBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>